import { render } from "./HandlerAndroid.vue?vue&type=template&id=d1834f90&scoped=true"
import script from "./HandlerAndroid.vue?vue&type=script&lang=js"
export * from "./HandlerAndroid.vue?vue&type=script&lang=js"

import "./HandlerAndroid.vue?vue&type=style&index=0&id=d1834f90&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1834f90"]])

export default __exports__